import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: '',
	blockDesc: '',
	buttonText: '',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: '',
	ButtonModalParams: {},
	blockContent: {
		top: {
			gap: 'gap-16-24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Сигурност без компромиси',
					text: 'Инфраструктурата ни е изградена с фокус върху защитата на твоя бизнес. Сигурен хостинг за твоя сайт и спокойствие.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				}
			]
		},
		bottom: {
			gap: 'gap-4-6', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'SH Protect',
					subtitle: 'система за сигурност',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '99.98% Uptime',
					subtitle: 'непрекъснат достъп',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'DDoS',
					subtitle: 'защита за всички услуги',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'Backup',
					subtitle: 'сигурен архив на съдържанието',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'Imunify360',
					subtitle: 'защита от ново поколение',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'Help desk',
					subtitle: 'премахване на злонамерен код',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'SSL',
					subtitle: 'професионални сертификати',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'Infrastructure',
					subtitle: 'съвременна технологична среда',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				}
			]
		}
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	blockDesc: '',
	buttonText: '',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: '',
	ButtonModalParams: {},
	blockContent: {
		top: {
			gap: 'gap-16-24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Security without compromise',
					text: 'Our infrastructure is built with a strong focus on protecting your business. Secure hosting for your website and complete peace of mind.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				}
			]
		},
		bottom: {
			gap: 'gap-4-6', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'SH Protect',
					subtitle: 'advanced security system',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '99.98% uptime',
					subtitle: 'continuous availability',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'DDoS protection',
					subtitle: 'included with all services',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'Backup',
					subtitle: 'secure data backups',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'Imunify360',
					subtitle: 'next-generation protection',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'Help Desk',
					subtitle: 'malware removal',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'SSL ',
					subtitle: 'professional certificates',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: 'Infrastructure',
					subtitle: 'modern technological environment',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				}
			]
		}
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];